/**
 * Capitalizes the first letter of a given string.
 * @param { string } string - The string to capitalize.
 * @returns { string } - The capitalized string.
 */
export const capitalizeString = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};